import { useDisclosure } from '@/hooks';
import './style.less';
import { Button, Tooltip } from 'antd';
import { Group } from '@/components/_common';
import { X } from 'react-feather';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import { truncateString } from '@/utils/functions/truncateString';
import { useDirectSaleContext } from '@/pages/MovementsPage/DirectSalePage/DirectSaleProvider';
import { useDirectSaleIncludeTag } from '@/core/domain/sales/DirectSale/DirectSale.hooks';
import TagsDirectSaleSelectModal from '@/components/Settings/Profiles/TagsDirectSale/TagsDirectSaleSelectModal';

export default function DirectSaleHeaderTag() {
  const { directSaleId, directSale, isLoading } = useDirectSaleContext();
  const [modalSelectTag, modalSelectTagActions] = useDisclosure();

  const directSaleIncludeTag = useDirectSaleIncludeTag();

  const saleTag = directSale?.saleTag;

  async function handleDirectSaleTag(tagId?: number) {
    if (directSaleId) {
      await directSaleIncludeTag.mutateAsync({
        saleId: Number(directSaleId),
        tagId,
      });
    }
  }

  return (
    <>
      <Group gap={4}>
        {!!saleTag ? (
          <>
            <Tooltip title={saleTag.name.toUpperCase() || ''}>
              <StatusTag
                size="lg"
                color={saleTag.color}
                label={truncateString(saleTag.name.toUpperCase(), 20)}
                onClick={modalSelectTagActions.open}
              />
            </Tooltip>

            <Button
              icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
              size="small"
              onClick={() => handleDirectSaleTag()}
            />
          </>
        ) : (
          <StatusTag
            color="default"
            size="lg"
            className="card-select-tag"
            label="Selecionar Etiqueta"
            onClick={modalSelectTagActions.open}
          />
        )}
      </Group>

      <TagsDirectSaleSelectModal
        onCancel={modalSelectTagActions.close}
        open={modalSelectTag}
        onCallback={handleDirectSaleTag}
        confirmLoading={isLoading || directSaleIncludeTag.isLoading}
      />
    </>
  );
}
